{
  "appName": "VASS",
  "entryFile": "./app-entry.jsx",
  "entryName": "vass",
  "rootUrl": "/service-member-benefits/solid-start/schedule",
  "productId": "b4e39943-c5e7-497a-ad26-8a1b9342cb97",
  "datadog": {
    "applicationId": "ccf85609-91e9-491d-a9b7-4641667b6f1d",
    "clientToken": "pubeb7de15146334acf2328b3a37ac7260a",
    "service": "vass",
    "toggleName": "vassBrowserMonitoringEnabled",
    "sessionReplaySampleRate": 1,
    "defaultPrivacyLevel": "mask"
  }
}
